import { regenDoseControllerLabelsId } from "./IXEvaluate.strings";
const {
  chemicalFlowId,
  dilutionFlowId,
  totalSolutionFlowId,
  totalSolutionVolumeId,
  concentrationId,
  doseId,
  regenTimeId,
  doseFractionId,
  regenerationRatioId,
} = regenDoseControllerLabelsId;

const overRunComputationId = {
  mannualId: 0,
  automaticId: 1,
};

const neutralWasteEffluentId = {
  notRequiredId: 0,
  requiredId: 1,
};

const doseOptimizationId = {
  notRequiredDoseId: 0,
  requiredDoseId: 1,
};

export const neutralOverrunDoseRadioId = { ...overRunComputationId, ...neutralWasteEffluentId, ...doseOptimizationId };

export const InitialExistingPlantValue = {
  resinVolumeAsDelivered: 0,
  vesselDiameter: 0,
  resinBedHeightAsDelivered: 0,
  resinBedStandardHeight: 0,
  resinBedHeightAsExhausted: 0,
  resinBedHeightAsRegenerated: 0,
  inertResinVolume: 0,
  inertBedHeight: 0,
  freeBoard: 0,
  vesselCylindricalHeight: 0,
  vesselWallThickness: 0,
  pressureDropwithRecomQty: 0,
  resinPackagingSize: 0,
};

export const regenerantDoseConst = {
  chemicalFlow: {
    name: chemicalFlowId,
    values: [0],
  },
  dilutionWaterFlow: {
    name: dilutionFlowId,
    values: [0],
  },
  totalSolutionFlow: {
    name: totalSolutionFlowId,
    values: [0],
  },
  totalSolutionVolume: {
    name: totalSolutionVolumeId,
    values: [0],
  },
  dose: {
    name: doseId,
    values: [1],
  },
  time: {
    name: regenTimeId,
    values: [0],
  },
  concentration: {
    name: concentrationId,
    values: [1],
  },
  doseFraction: {
    name: doseFractionId,
    values: [0],
  },
  regenerationRatio: {
    name: regenerationRatioId,
    values: [0],
  },
};
export const EvalProtocolOneRegen = {
  regenerantID: 0,
  chemicalID: 0,
  temperatureID: 0,
  temperature: 0,
  serviceWater: null,
  backwash: null,
  evaluateRegenCondId: 0,
  regenProtocol: 0,
  selectedPropertyName: doseId,
  regenerantDose: regenerantDoseConst,
};

export const regenOptionMapping = {
  CHEMICAL_FLOW: 1,
  TOTAL_SOLUTION_FLOW: 2,
  TOTAL_SOLUTION_VOLUME: 3,
  DOSE: 4,
};

export const enableDisabledRegenerantField = {
  CHEMICAL_FLOW: [chemicalFlowId, dilutionFlowId, regenTimeId],
  TOTAL_SOLUTION_FLOW: [totalSolutionFlowId, regenTimeId, concentrationId],
  TOTAL_SOLUTION_VOLUME: [totalSolutionVolumeId, regenTimeId, concentrationId],
  DOSE: [doseId, concentrationId],
  REGENERATION_RATIO: [regenerationRatioId, concentrationId],
};

export const regenerantAdditionalFields = t => [
  {
    label: t("existingRegeneration.TimeMin"),
    values: ["", "", ""],
    id: regenTimeId,
    controller: "time",
  },
  {
    label: t("existingRegeneration.Concentration"),
    values: ["", "", ""],
    id: concentrationId,
    controller: "concentration",
  },
];

export const regenDoseFieldsValues = ["", "", ""];

export const stepIndicator = {
  stepOne: 1,
  stepTwo: 2,
  stepThree: 3,
};

export const regenSVRanges = {
  minValue: 1,
  maxValue: 40,
};

export const regenerantDoseDefaultValue = {
  CHEMICAL_FLOW: 1,
  DILUTION_WATER_FLOW: 1,
  TOTAL_SOLUTION_FLOW: 1,
  TOTAL_SOLUTION_VOLUME: 1,
  DOSE: 1,
  CONCENTRATION: 1,
  REGENERATION_RATIO: 1,
  TIME: 30,
};

export const evalRegenInitialState = {
  protocol1Validation: false,
  protocol2Validation: false,
  regenSVProt1Validation: false,
  regenSVProt2Validation: false,
};

export const regenerantDosesRangeLimit = {
  minimumRegenLimit: 0,
  minimunRegenRatioLimit: 99,
  maxFlowVolumeLimit: 2500,
  maxDoseLimit: 750,
  maxRegenTimeLimit: 120, //(in minute)
  maxVolumeLimit: 2500,
  maxRegenOverRunLimit: 200,
  maxRegenRatioLimit: 10000,
  maxConcCarbonateSaltLimit: 13,
  maxConcAcidBaseLimit: 8,
};

export const overRunRanges = {
  minimumOverRun: 0,
  maxOverRunNewPlant: 100,
  maxOverRunEvalPlant: 200,
};

export const modellingObjectiveSource = {
  newPlantSource: "newResetDesign",
  evaluateSource: "evaluateExisting",
  retroFitSource: "retrofitPlant",
  copyNewPlantSource: "copyPlant",
  createEvalNewPlantSource: "resetNewPlant",
};
